<template>
  <div>
    <el-dialog
        title="兑换商品"
        :visible.sync="exchangeDialog"
        width="800px" >
      <div style="margin-left: 30px" v-loading="exchangeLoading">
        <el-form label-position="top" :model="exchangeItem" :rules="rules" ref="formRef" label-width="110px">
          <el-row>
            <el-col :span="11">
              <el-form-item label-width="100px" label="教练姓名" prop="coachId">
                <el-input v-model="exchangeItem.coachName" disabled style="width: 230px" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label-width="100px" label="剩余积分" prop="score">
                <el-input-number v-model="exchangeItem.score" disabled style="width: 230px" :min="1" :max="10000"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="100px" label="兑换商品" prop="pointsMallId">
                <el-select
                    v-model="exchangeItem.pointsMallId" style="width: 260px;"
                    filterable placeholder="请选择" :loading="productLoading"
                    remote reserve-keyword :remote-method="selectAllProduct">
                  <el-option v-for="(item,index) in productList" :key="index" :disabled="item.isDelete == 1 ? true:false" :label="item.name" :value="item.id">
                    <span style="float: left">{{ item.id }} - {{item.name}}</span>
                    <span style="float: right; color: #8492a6;font-size: 12px">{{ item.score }}积分</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exchangeDialog = false">取 消</el-button>
        <el-button type="danger" :disabled="exchangeLoading" @click="created">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {exchangeProduct,selectAllProduct} from '/src/api/contacts/hr/product.js'
export default {
  name: "ExchangeProduct",
  data() {
    return {
      exchangeDialog: false,
      exchangeLoading: false,
      productLoading:false,
      productList:[],
      exchangeItem: {
        coachId:null,
        score:null,
        pointsMallId:null
      },
      coach:{},
      rules: {
        coachId: [{ required: true, message: "教练Id有误！！", trigger: "blur" }],
        score: [{ required: true, message: "积分不足！！！", trigger: "blur" }],
      }
    };
  },
  methods:{
    openDialog(item) {
      this.exchangeDialog = true;
      this.exchangeItem = JSON.parse(JSON.stringify(item));
      this.selectAllProduct();
    },
    selectAllProduct(val){
      this.productLoading = true;
      selectAllProduct({name:val ? val:''}).then(val=>{
        if (val.status == 200){
          this.productLoading = false;
          this.productList = val.data;
          this.productList.forEach((item) =>{
            if (item.score>this.exchangeItem.score){
              item.isDelete = 1;
            }
          })
        }
      })
    },
    created(){
      console.log(this.exchangeItem)
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.exchangeLoading = true;
          exchangeProduct(this.exchangeItem).then(val=>{
            this.exchangeLoading = false;
            if (val.status == 200){
              this.$emit('refresh');
              this.exchangeDialog = false;
              this.$notify.success({title: '提示', message: '兑换成功！', offset: 40});
              Object.keys(this.ruleItem).forEach((key) => (this.ruleItem[key] = null));
            }else {
              this.$notify.error({title: '兑换失败！', message: val.data, offset: 40});
            }
          })
        }
      })
    },

  },
}

</script>

<style scoped>

</style>




